/** Bridge so frame scripts can request a canvas repaint without threading the
 *  canvas ref through the render tree. CanvasSurface registers a callback that
 *  calls `canvas.requestPaint()`; in DOM mode nothing registers → no-op. */
let invalidator: (() => void) | null = null;

export function setCanvasInvalidator(fn: (() => void) | null): void {
  invalidator = fn;
}

export function invalidateCanvas(): void {
  invalidator?.();
}
